import React from 'react';
import { Flex, Box } from 'theme-ui';
import Reveal from '@solid-ui-components/Reveal';
import FlexImage from '@solid-ui-components/FlexImage';
import FlexContent from '@solid-ui-components/FlexContent';
import ContentText from '@solid-ui-components/ContentText';
import ContentImages from '@solid-ui-components/ContentImages';
import ContentButtons from '@solid-ui-components/ContentButtons';
import styles from './styles';
import ListItem from '@solid-ui-components/ListItem';

const getBackgroundColorByVariant = (variant) => {
  switch (variant) {
    case 'green':
      return '#F6FDFD';
    case 'blue':
      return '#F5FBFF';
    case 'yellow':
      return '#FEFBE8';
    case 'purple':
      return '#FDF4FF';
  }
};

const getWrapperStylesByVariant = (variant) => {
  const color = getBackgroundColorByVariant(variant);
  return variant
    ? {
      p: ['40px', 0, 0, 0, '40px'],
      borderRadius: ['20px', 0, 0, 0, '20px'],
      backgroundColor: [
        color,
        'transparent',
        'transparent',
        'transparent',
        color,
      ],
    }
    : {};
};

const RenderedListItem = ({ index, text, icon, iconStyles }, start = 0) => (
  <Reveal delay={start + 0.5 * index}>
    <ListItem iconStyles={iconStyles} icon={icon} text={text} />
  </Reveal>
);

const FeatureWithIconList02 = ({
  content: { text, images, collection },
  reverse,
  top,
  variant,
}) => {
  const { buttons, icon } = collection[0];
  const color = getBackgroundColorByVariant(variant);
  return (
    <Box sx={styles.container}>
      <ContentText content={text} />
      <Flex
        sx={{
          ...styles.flexContainer,
          flexDirection: [
            'column-reverse',
            null,
            null,
            null,
            reverse ? 'row-reverse' : 'row',
          ],
          alignContent: 'center',
          alignItems: 'center',
          py: [0, '40px', '40px', '40px', 0],
          px: [0, '20px', '20px', '40px', 0],
          backgroundColor: ['transparent', color, color, color, 'transparent'],
          borderRadius: [0, '20px', '20px', '20px', 0],
        }}
      >
        <FlexImage>
          <ContentImages
            content={{ images }}
            reverse={reverse}
            imagePosition='center'
          />
        </FlexImage>
        <FlexContent
          reverse={reverse}
          width='100%'
          p={[null, 0, null, null, '0 0 0 20px']}
          sx={getWrapperStylesByVariant(variant)}
        >
          {collection && (
            <>
              <Flex sx={styles.listItemContainer}>
                {collection[0]?.text?.map((text, index) => (
                  <RenderedListItem
                    key={`item0-${index}`}
                    text={text}
                    icon={icon}
                    index={index}
                  />
                ))}
                {collection[0]?.collection?.map((props, index) => (
                  <RenderedListItem
                    key={`item1-${index}`}
                    {...props}
                    index={index}
                    start={1}
                  />
                ))}
                {buttons && (
                  <Reveal effect={'fadeInLeft'}>
                    <ContentButtons
                      content={buttons}
                      wrapperStyles={styles.buttonsWrapper}
                    />
                  </Reveal>
                )}
              </Flex>
            </>
          )}
        </FlexContent>
      </Flex>
    </Box>
  );
};

export default FeatureWithIconList02;
